import axios from 'axios';

// 强制使用本地代理，避免连接到生产服务器
let API_BASE_URL = '/api';

// 如果设置了环境变量，检查是否是生产服务器地址
if (process.env.VUE_APP_API_BASE_URL) {
  const envUrl = process.env.VUE_APP_API_BASE_URL;
  
  // 如果是生产服务器地址，强制使用本地代理并警告
  if (envUrl.startsWith('http://') || envUrl.startsWith('https://')) {
    const isProduction = !envUrl.includes('localhost') && !envUrl.includes('127.0.0.1');
    if (isProduction) {
      console.error('⚠️ 严重警告：登录API环境变量指向生产服务器！');
      console.error(`环境变量 VUE_APP_API_BASE_URL: ${envUrl}`);
      console.error('已强制使用本地代理 /api，避免影响生产环境');
      // 强制使用本地代理
      API_BASE_URL = '/api';
    } else {
      // 本地地址，可以使用
      API_BASE_URL = envUrl;
    }
  } else {
    // 相对路径，可以使用
    API_BASE_URL = envUrl;
  }
}

/**
 * 用户登录
 * @param {Object} credentials - 包含用户名和密码的对象
 * @returns {Promise} - 返回登录结果的Promise
 */
export const login = async (credentials) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, credentials);
    return response.data;
  } catch (error) {
    console.error('登录失败:', error);
    throw error;
  }
};

/**
 * 验证令牌有效性
 * @returns {Promise} - 返回令牌验证结果的Promise
 */
export const verifyToken = async () => {
  try {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      throw new Error('未找到令牌');
    }

    const response = await axios.get(`${API_BASE_URL}/auth/verify`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('令牌验证失败:', error);
    throw error;
  }
};

/**
 * 用户登出
 */
export const logout = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
};